<template>
  <div v-if="api_data.Farmer" id="operationLandInformation">
    <div class="card rounded-0 card-custom gutter-b">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="card-label">
            <div class="font-weight-bolder">
              {{ $t('Forest Land (Claimed Land)') }}
            </div>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t('Information') }}</span>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <div class="form-group">
              <label>{{ $t("Acre") }}</label>
              <input class="form-control form-control-solid"
                     v-model="api_data.Farmer.land_forest_claimed_land_acre"
                     placeholder="Acre">
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>{{ $t('Guntha') }}</label>
              <input class="form-control form-control-solid"
                     v-model="api_data.Farmer.land_forest_claimed_land_guntha"
                     placeholder="Guntha">
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group">
              <label>{{ $t('Claim Application Number') }}</label>
              <input class="form-control form-control-solid input-lg"
                     v-model="api_data.Farmer.land_forest_claim_application_number"
                     placeholder="Claim Application Number">
            </div>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_cultivation'"
            v-bind:head_title="'Forest Cultivation'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_residence'"
            v-bind:head_title="'Residence'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_natural_trees'"
            v-bind:head_title="'Natural Trees'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_grown_trees'"
            v-bind:head_title="'Grown Trees'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_house'"
            v-bind:head_title="'Forest Land House'"
            v-bind:default_autocomplete_list="land_forest_house_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_well'"
            v-bind:head_title="'Forest Land Well'"
            v-bind:default_autocomplete_list="land_forest_well_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_engine'"
            v-bind:head_title="'Forest Land Engine'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_pala'"
            v-bind:head_title="'Forest Land Pala'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_trench'"
            v-bind:head_title="'Forest Land Trench'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_improvement_projects'"
            v-bind:head_title="'Forest Land Improvement Projects'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_evidence_farmers_record_book'"
            v-bind:head_title="'Forest Land Evidence Book Registration'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_evidence_bunds'"
            v-bind:head_title="'Bunds (Forest Land Evidence Book Registration)'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_evidence_trees'"
            v-bind:head_title="'Trees (Forest Land Evidence Book Registration)'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_evidence_farm_pond'"
            v-bind:head_title="'Pond (Forest Land Evidence Book Registration)'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_evidence_gps_map'"
            v-bind:head_title="'GPS Map (Forest Land Evidence Book Registration)'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <div class="row">
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("Acre") }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_forest_entitlement_acre"
                         placeholder="Acre">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('Guntha') }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_forest_entitlement_guntha"
                         placeholder="Guntha">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'land_forest_entitlement'"
                v-bind:head_title="'Forest Land Entitlement Information'"
                v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
                v-bind:default_question_options="default_question_options"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_cultivating_land_through_receipt'"
            v-bind:head_title="'Forest Land Received Through Receipt'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_forest_received_through_claim'"
            v-bind:head_title="'Forest Land Received Through Claim'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <div class="row">
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("Acre") }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_forest_cultivating_land_measured_acre"
                         placeholder="Acre">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('Guntha') }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_forest_cultivating_land_measured_guntha"
                         placeholder="Guntha">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'land_forest_cultivating_land_measured'"
                v-bind:head_title="'Cultivating Land Measurement'"
                v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
                v-bind:default_question_options="default_question_options"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t('East (Claimed Land)') }}</label>
              <input class="form-control form-control-solid"
                     v-model="api_data.Farmer.land_forest_claimed_east"
                     placeholder="East">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t('West (Claimed Land)') }}</label>
              <input class="form-control form-control-solid"
                     v-model="api_data.Farmer.land_forest_claimed_west"
                     placeholder="West">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t('North (Claimed Land)') }}</label>
              <input class="form-control form-control-solid"
                     v-model="api_data.Farmer.land_forest_claimed_north"
                     placeholder="North">
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label>{{ $t('South (Claimed Land)') }}</label>
              <input class="form-control form-control-solid"
                     v-model="api_data.Farmer.land_forest_claimed_south"
                     placeholder="South">
            </div>
          </div>
        </div>
        <store-short-data-from-json
            :api_data="api_data"
            v-bind:head_title="'Forest Land Nominees Names'"
            v-bind:data_in_json_input="'land_forest_nominees'"
        ></store-short-data-from-json>
        <div class="row">
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("Acre") }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_revenue_acre"
                         placeholder="Acre">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('Guntha') }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_revenue_guntha"
                         placeholder="Guntha">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'land_revenue'"
                v-bind:head_title="'Revenue Land'"
                v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
                v-bind:default_question_options="default_question_options"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <text-input
            v-bind:form_label="'7-12-8 Number'"
            v-bind:form_class="'form-control-solid input-lg'"
            v-bind:file_input_name="'land_revenue_7_12_8'"
            :api_data="api_data"
        ></text-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_revenue_inherited'"
            v-bind:head_title="'Revenue Land Inherited ?'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'land_revenue_livelihood'"
            v-bind:head_title="'Revenue Land Livelihood ?'"
            v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
            v-bind:default_question_options="default_question_options"
        ></question-with-note-and-multi-input>
        <div class="row">
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("Acre") }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_revenue_irrigation_acre"
                         placeholder="Acre">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('Guntha') }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_revenue_irrigation_guntha"
                         placeholder="Guntha">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'land_revenue_irrigation_facility'"
                v-bind:head_title="'Revenue Land Irrigation Facility ?'"
                v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
                v-bind:default_question_options="default_question_options"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("Acre") }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_monsoon_acre"
                         placeholder="Acre">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('Guntha') }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_monsoon_guntha"
                         placeholder="Guntha">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'land_monsoon'"
                v-bind:head_title="'Monsoon Irrigation ?'"
                v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
                v-bind:default_question_options="default_question_options"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("Acre") }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_government_graze_land_acre"
                         placeholder="Acre">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('Guntha') }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_government_graze_land_guntha"
                         placeholder="Guntha">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'land_government_graze_land'"
                v-bind:head_title="'Government Graze Land (Monsoon) ?'"
                v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
                v-bind:default_question_options="default_question_options"
            ></question-with-note-and-multi-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t("Acre") }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_graze_land_acre"
                         placeholder="Acre">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('Guntha') }}</label>
                  <input class="form-control form-control-solid"
                         v-model="api_data.Farmer.land_graze_land_guntha"
                         placeholder="Guntha">
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <question-with-note-and-multi-input
                :api_data="api_data"
                v-bind:file_input_name="'land_graze_land'"
                v-bind:head_title="'Barren Land (Monsoon) ?'"
                v-bind:default_autocomplete_list="land_forest_cultivation_default_autocomplete"
                v-bind:default_question_options="default_question_options"
            ></question-with-note-and-multi-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'operation-land-information',
  props: {
    api_data: Object,
  },
  data: () => ({
    land_forest_cultivation_default_autocomplete: [],
    land_forest_house_default_autocomplete: [
      'કાચું', 'પાકું', 'Raw', 'Complete'
    ],
    land_forest_well_default_autocomplete: [
      'કાચું', 'પાકું', 'Raw', 'Complete'
    ],
    default_question_options: [
      {
        'label': 'Yes',
        'value': 'yes',
      },
      {
        'label': 'No',
        'value': 'no',
      },
    ],
  })
}
</script>
